import { CPopover } from "@coreui/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";

const AccountPermissionsHelp = () => {
  const { t } = useTranslation();
  const popover = useRef(null);

  return (
    <CPopover
      header={t("shared.permissionHelp.title")}
      placement="bottom-start"
      trigger="click"
      interactive
      advancedOptions={{
        maxWidth: 360,
        aria: { content: "describedby" },
        onCreate: (instance) => { popover.current = instance; },
      }}
      content={
        <>
          <p>{t("shared.permissionHelp.levels")}</p>
          <p>
            <strong>{t("shared.permissionHelp.status")}</strong><br />
            {t("shared.permissionHelp.review")}
          </p>
          <p className="mb-0">{t("shared.permissionHelp.guidance")}</p>
        </>
      }
    >
      <button
        type="button"
        className="btn btn-link btn-sm px-0"
        onKeyDown={(event) => {
          if (event.key === "Escape" && popover.current?.state.isVisible) {
            event.stopPropagation();
            popover.current?.hide();
          }
        }}
      >
        <BsInfoCircle className="mr-1" aria-hidden="true" />
        {t("shared.permissionHelp.button")}
      </button>
    </CPopover>
  );
};

export default AccountPermissionsHelp;
